import userApi from 'common/api/user';

export const resetPassword = async (email: string) => {
  try {
    await userApi.auth.resetPassword(email);
    return 0;
  } catch (e) {
    throw e;
  }
};